import axios from "axios";
import { createAction } from "redux-actions";
import { call, put, takeLatest } from "redux-saga/effects";
import buildUrl from "build-url";

import { FETCHING_ACCOUNT_ASSETS_PROCESSING_METRICS, FETCHING_ACCOUNT_ASSETS_PROCESSING_METRICS_FAILED, FETCHING_ACCOUNT_ASSETS_PROCESSING_METRICS_SUCCEED, FETCHING_ACCOUNT_DATASOURCE_MAPPING_METRICS, FETCHING_ACCOUNT_DATASOURCE_MAPPING_METRICS_FAILED, FETCHING_ACCOUNT_DATASOURCE_MAPPING_METRICS_SUCCEED } from "constants/actionTypes";

const apiUrl = process.env.REACT_APP_API_URL;
const apiUrlV2 = process.env.REACT_APP_API_URL_V2;

const METRICS_SOURCE_BASE_URL = `${apiUrlV2}/admin/3.0/support-metrics`;
const ASSET_METRICS_URL = `${METRICS_SOURCE_BASE_URL}/assets/top-accounts`;
const DATASOURCE_METRICS_URL = `${METRICS_SOURCE_BASE_URL}/datasource/top-accounts`;

export const fetchAssetsMetrics = createAction(FETCHING_ACCOUNT_ASSETS_PROCESSING_METRICS);

const fetchAccountAssetsMetricsSucceded = createAction(FETCHING_ACCOUNT_ASSETS_PROCESSING_METRICS_SUCCEED);

const fetchAccountAssetsMetricsFailed = createAction(FETCHING_ACCOUNT_ASSETS_PROCESSING_METRICS_FAILED);

function* fetchAccountAssetsMetrics(action) {
  let { page, limit } = action.payload;    
  let url = buildUrl(ASSET_METRICS_URL);
  const fetchAccountAssetsMetricsAPI = () => {

    return axios({
      method: "POST",
      url: url,
      params: { page, limit },
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchAccountAssetsMetricsAPI);
    yield put(fetchAccountAssetsMetricsSucceded(response));
  } catch (error) {
    yield put(fetchAccountAssetsMetricsFailed(error));
  }
}

export const fetchDatasourceMappingMetrics = createAction(FETCHING_ACCOUNT_DATASOURCE_MAPPING_METRICS);

const fetchAccountDatasourceMappingMetricsSucceded = createAction(FETCHING_ACCOUNT_DATASOURCE_MAPPING_METRICS_SUCCEED);

const fetchAccountDatasourceMappingMetricsFailed = createAction(FETCHING_ACCOUNT_DATASOURCE_MAPPING_METRICS_FAILED);

function* fetchAccountDatasourceMappingMetrics(action) {
  let { page, limit } = action.payload;

  let url = buildUrl(DATASOURCE_METRICS_URL);
  const fetchAccountDatasourceMappingMetricsAPI = () => {

    return axios({
      method: "POST",
      url: url,
      params: { page, limit },
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchAccountDatasourceMappingMetricsAPI);
    yield put(fetchAccountDatasourceMappingMetricsSucceded(response));
  } catch (error) {
    yield put(fetchAccountDatasourceMappingMetricsFailed(error));
  }
}

export default function* accountMetricsSaga() {
  yield takeLatest(FETCHING_ACCOUNT_ASSETS_PROCESSING_METRICS, fetchAccountAssetsMetrics);
  yield takeLatest(FETCHING_ACCOUNT_DATASOURCE_MAPPING_METRICS, fetchAccountDatasourceMappingMetrics);
}